import { render, staticRenderFns } from "./quotation-info-quotation.vue?vue&type=template&id=19f31c7e"
import script from "./quotation-info-quotation.vue?vue&type=script&lang=js"
export * from "./quotation-info-quotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f31c7e')) {
      api.createRecord('19f31c7e', component.options)
    } else {
      api.reload('19f31c7e', component.options)
    }
    module.hot.accept("./quotation-info-quotation.vue?vue&type=template&id=19f31c7e", function () {
      api.rerender('19f31c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-info-quotation.vue"
export default component.exports